import React, { useState } from 'react';
import { Button, Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Folder2 } from 'react-bootstrap-icons';
import { Redirect, Route, Switch, withRouter } from 'react-router';
import NotFound from '../../components/NotFound';
import CachedResponse from '../common/CachedResponse';
import FileExplorerSidebar from '../common/file-explorer/FileExplorerSidebar';
import PrintGroupsV2 from '../doc-hub-v2/PrintGroupsV2';
import {
  DOCHUB_USEFUL_FILES_FOLDER,
  ROLE_ADMIN,
  ROLE_INVENTORY_MANAGER,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SERVICE,
  ROLE_SUPER_ADMIN
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';
import '../common/file-explorer/FileExplorer.scss';

const DocHub = () => {
  const [showUsefulFiles, setShowUsefulFiles] = useState(false);

  if (
    !userHasAnyRole(
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_SALES,
      ROLE_SALES_MANAGER,
      ROLE_SERVICE,
      ROLE_INVENTORY_MANAGER,
      ROLE_SALES_AND_INVENTORY_MANAGER
    )
  ) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/dochub/print-groups">
          <CachedResponse
            listEndpoint={'app-choices'}
            render={appChoices => <PrintGroupsV2 appChoices={appChoices} />}
          />
        </Route>
        {/* Legacy V2 URL — keep bookmarks working */}
        <Route
          exact
          path="/dochub/v2"
          render={({ location }) => (
            <Redirect to={{ pathname: '/dochub/print-groups', search: location.search }} />
          )}
        />
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  return (
    <>
      <Container fluid className="px-0 h-100">
        {getActivePage()}
      </Container>

      {!showUsefulFiles && (
        <OverlayTrigger
          placement="left"
          overlay={<Tooltip id="useful-files-tooltip">Useful Files</Tooltip>}
        >
          <Button
            className="file-explorer-fab rounded-circle p-0"
            variant="dark"
            onClick={() => setShowUsefulFiles(true)}
          >
            <Folder2 size={20} />
          </Button>
        </OverlayTrigger>
      )}

      <FileExplorerSidebar
        show={showUsefulFiles}
        onHide={() => setShowUsefulFiles(false)}
        parentFolderName={DOCHUB_USEFUL_FILES_FOLDER}
        title="Useful Files"
        zIndex={1040}
      />
    </>
  );
};

export default withRouter(DocHub);
